<template>
  <div class="search-container">
    <input
      type="text"
      @keypress.enter="onSearch"
      v-model="search"
      placeholder="Search something.."
    />
    <i class="fas fa-search search-icon"></i>
    <i @click="reset" v-if="search" class="fas fa-times reset-icon"></i>
  </div>
</template>

<script>
export default {
  methods: {
    reset() {
      const { name } = this.$router.currentRoute;
      switch (name) {
        case "vehicles":
          this.$store.commit("vehicle/SET_SEARCH", "");
          break;
        case "home":
          this.$store.commit("analysis/SET_SEARCH", "");
          break;
        case "vehicle-advanced":
          this.$store.commit("profit/SET_SEARCH", "");
          break;
        case "for-sale":
          this.$store.commit("profit/SET_SEARCH", "");
          break;
        case "blackbook":
          this.$store.commit("profit/SET_SEARCH", "");
          break;
        case "vehicle-class-performance":
          this.$store.commit("vehicleClassPerformance/SET_SEARCH", "");
          break;
        case "mileage":
          this.$store.commit("millage/SET_SEARCH", "");
          break;
        case "operation-reports":
          this.$store.commit("reports/SET_SEARCH", null);
          break;
        default:
          break;
      }
      this.search = "";
    },
    onSearch() {
      const { name } = this.$router.currentRoute;
      switch (name) {
        case "vehicles":
          this.$store.commit("vehicle/SET_SEARCH", this.search);
          this.searchDialog = false;
          break;
        case 'vehicle-class-performance':
          this.$store.commit('vehicleClassPerformance/SET_SEARCH', this.search)
          this.searchDialog = false
          break
        case "home":
          this.$store.commit("analysis/SET_SEARCH", this.search);
          this.searchDialog = false;
        case "mileage":
          this.$store.commit("millage/SET_SEARCH", this.search);
          break;
        case "vehicle-advanced":
          this.$store.commit("profit/SET_SEARCH", this.search);
          break;
        case "for-sale":
          this.$store.commit("profit/SET_SEARCH", this.search);
          break;
        case "blackbook":
          this.$store.commit("profit/SET_SEARCH", this.search);
          break;
        case "operation-reports":
          this.$store.commit("reports/SET_SEARCH", this.search);
          break;
        default:
          break;
      }
    },
  },
  data() {
    return {
      search: "",
    };
  },
  watch: {
    "$route.name": {
      deep: true,
      immediate: true,
      handler(n, o) {
        this.reset();
      },
    },
  },
};
</script>

<style lang="scss">
.search-container {
  position: relative;
  display: flex;
  align-items: center;
  flex: 0 1 400px;
  input {
    color: #000 !important;
    width: 100%;
    text-indent: 25px;
    border-radius: 5px;
    border: none;
    background: #ffffff;
    padding: 10px;
    outline: none;
  }
  .search-icon {
    left: 10px;
    font-size: 16px;
    color: #666666;
    position: absolute;
  }
  .reset-icon {
    position: absolute;
    right: 10px;
    font-size: 16px;
    color: #666666;
    cursor: pointer;
  }
}
</style>
